import {
	AeroexpressClass,
	AeroexpressDirection,
	AeroexpressTrip,
	Trip_AeroexpressTrip_Fragment
} from '@websky/graphql';
import { getStringsHasChanges } from '../../../utils';

export const ROUND_TRIP_CLASSES = [
	AeroexpressClass.roundtrip,
	AeroexpressClass.roundTrip,
	AeroexpressClass.business_roundtrip,
	AeroexpressClass.couple_roundtrip,
	AeroexpressClass.family_roundtrip
];

export const isRoundTrip = (trip: Trip_AeroexpressTrip_Fragment): boolean => {
	return (
		(ROUND_TRIP_CLASSES.includes(trip.class) || trip.fromStation?.direction === AeroexpressDirection.Roundtrip) &&
		trip.segments?.length > 1
	);
};

const getSelectedServicesKeys = (services: AeroexpressTrip[]) => {
	const selectedServicesSet = new Set<string>();

	services.forEach(service => {
		const key = [service.id, service.fromStation.name, service.toStation.name, service.departureDate].join('-');

		selectedServicesSet.add(key);
	});

	return [...selectedServicesSet].sort();
};

export const getAeroexpressHasChanges = (initialServices: AeroexpressTrip[], selectedServices: AeroexpressTrip[]) => {
	const initialKeys = getSelectedServicesKeys(initialServices);
	const selectedKeys = getSelectedServicesKeys(selectedServices);

	return getStringsHasChanges(initialKeys, selectedKeys);
};
